export default "__VITE_ASSET__Cpb$Fjxi__"